<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Za45zj/tc-custom/9780310296065.jpg?1726454431648" alt="This image is the cover for the book If You Want to Walk on Water, You've Got to Get Out of the Boat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If You Want to Walk on Water, You've Got to Get Out of the Boat
      </h1>
      <p class="bookDescription body article font2">
        <p><b>You're one step away from the adventure of your life. John Ortberg invites you to consider the incredible potential that awaits you outside your comfort zone.</b></p><p>Deep within you lies the same faith and longing that sent Peter walking across the wind-swept Sea of Galilee toward Jesus. In what ways is the Lord telling you, as he did Peter, "Come"?</p><p>Out on the risky waters of faith, Jesus is waiting to meet you in ways that will change you forever, deepening your character and your trust in God. The experience is terrifying. It's thrilling beyond belief. It's everything you'd expect of someone worthy to be called Lord.</p><p>The choice is yours to know him as only a water-walker can, aligning yourself with God's purpose for your life in the process. There's just one requirement: <i>If You Want to Walk on Water, You've Got to Get Out of the Boat.</i></p><p>In this <i>Christianity Today</i> Award-winning read, bestselling author John Ortberg pushes you to take the last step that separates you from the adventure of your life. And, as a result, you will learn to:</p>Recognize God's presenceDiscern between faith and foolishnessNot only expect problems, but field them when they comeReorient your thoughts about failure and see it as an opportunity to growWait on the LordAnd, ultimately, connect more deeply with God<p>Features discussion questions at the end of each chapter to enhance your reflection and spiritual growth. Also perfect for small group discussion.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ortberg
      </h2>
      
      <p class="authorDescription body article"><P>John Ortberg is the senior pastor of Menlo Park Presbyterian Church (MPPC) in the San Francisco Bay Area. His bestselling books include <I>Soul Keeping</I>, <I>Who Is This Man?</I>, and <I>If You Want to Walk on Water, You&rsquo;ve Got to Get Out of the Boat</I>. John teaches around the world at conferences and churches, writes articles for Christianity Today and Leadership Journal, and is on the board of the Dallas Willard Center and Fuller Seminary. He has preached sermons on Abraham Lincoln, The LEGO Movie, and The Gospel According to Les Miserables. John and his wife Nancy enjoy spending time with their three adult children, dog Baxter, and surfing the Pacific. You can follow John on twitter @johnortberg or check out the latest news/blogs on his website at <a href="http://www.johnortberg.com">www.johnortberg.com</a>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2cfcf9ad